import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslateDirective } from '@ngx-translate/core'
import { CalendarSyncState } from '../calendar-sync.service'
import { ProgressLoaderComponent } from '../common/progress-loader/progress-loader.component'

@Component({
  selector: 'app-calendar-sync-state',
  standalone: true,
  imports: [TranslateDirective, ProgressLoaderComponent, RouterLink],
  templateUrl: './calendar-sync-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './calendar-sync-state.component.scss',
})
export class CalendarSyncStateComponent {
  @Input()
  state!: Exclude<CalendarSyncState, 'IDLE'>
}
